// Language context - persists selected language in localStorage.
import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const LangContext = createContext(null);
const LANG_KEY = "lv.lang";

// Fallback if /api/languages hasn't loaded yet — English only, for now,
// matching SUPPORTED_LANGS in backend/server.py (the real source of
// truth this is only standing in for during that brief window). Kept
// the other languages' labels here rather than trimming them too, so
// re-enabling later only means changing DEFAULT_SUPPORTED/DEFAULT_RTL
// back (and the one line in server.py) — nothing to re-type.
const DEFAULT_LABELS = { en: "English", ar: "العربية", ur: "اردو", hi: "हिन्दी", fr: "Français", es: "Español", tr: "Türkçe", ms: "Bahasa Melayu", id: "Bahasa Indonesia", bn: "বাংলা" };
const DEFAULT_SUPPORTED = ["en"];
const DEFAULT_RTL = ["ar", "ur"];

export function LanguageProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem(LANG_KEY) || "en");
    const [meta, setMeta] = useState({ supported: DEFAULT_SUPPORTED, labels: DEFAULT_LABELS, rtl: DEFAULT_RTL });

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/languages");
                setMeta(data);
            } catch { /* keep defaults */ }
        })();
    }, []);

    useEffect(() => {
        localStorage.setItem(LANG_KEY, lang);
        document.documentElement.lang = lang;
        document.documentElement.dir = meta.rtl?.includes(lang) ? "rtl" : "ltr";
    }, [lang, meta.rtl]);

    return (
        <LangContext.Provider value={{ lang, setLang, ...meta, isRTL: meta.rtl?.includes(lang) }}>
            {children}
        </LangContext.Provider>
    );
}

export const useLang = () => useContext(LangContext);
